import { motion } from "framer-motion";
import type { ReactNode } from "react";

interface ParagraphProps {
  children: Readonly<ReactNode>;
}


export default function Paragraph({ children }: ParagraphProps) {
  return (
    <p
      className="mt-4 mb-3 text-lg leading-tight font-light text-gray-300 sm:text-xl"
    >
      {children}
    </p>
  );
}
